import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalFilterService } from '../../shared-services/global-filter-service';

@Component({
  selector: 'app-dynamic-notes',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dynamic-notes.component.html',
  styleUrl: './dynamic-notes.component.scss'
})
export class DynamicNotesComponent implements OnInit, OnDestroy {
  @Input() data: any;

  showNote = false;
  clauseText = '';
  staticText = '';
  private filterSub?: Subscription;

  constructor(private globalFilterService: GlobalFilterService) { }

  ngOnInit(): void {
    this.staticText = this.data?.staticText || 'Buyer Commitment - 10000 Units';

    const currentFilters = this.globalFilterService.getCurrentFilters();
    this.syncNote(currentFilters);

    this.filterSub = this.globalFilterService.filter$.subscribe((filterData) => {
      const filterKey = this.getFilterKey();
      const shouldHandleChange =
        !filterData?.changedFilterKey || filterData.changedFilterKey === filterKey;

      if (!shouldHandleChange) {
        return;
      }

      this.syncNote(filterData);
    });
  }

  ngOnDestroy(): void {
    this.filterSub?.unsubscribe();
  }

  private syncNote(filterData: any): void {
    const selectedValues = this.extractSelectedValues(filterData, this.getFilterKey());

    if (selectedValues.length === 0) {
      this.showNote = false;
      this.clauseText = '';
      return;
    }

    const selectedValue = selectedValues[0];
    this.clauseText = this.resolveClauseText(selectedValue);
    this.showNote = this.clauseText.length > 0;
  }

  private resolveClauseText(selectedValue: string): string {
    const clauseMap = this.data?.clauseMap || {};
    return String(clauseMap[selectedValue] || selectedValue || '').trim();
  }

  private getFilterKey(): string {
    return this.data?.filterKey || 'termsAndConditions';
  }

  private extractSelectedValues(filters: any, filterKey: string): string[] {
    const rawValue = filters?.requestParams?.[filterKey] ?? filters?.queryParams?.[filterKey];

    if (Array.isArray(rawValue)) {
      return rawValue
        .flatMap((value) => (Array.isArray(value) ? value : [value]))
        .map((value) => (value === undefined || value === null ? '' : String(value).trim()))
        .filter((value) => value.length > 0);
    }

    const singleValue = rawValue === undefined || rawValue === null ? '' : String(rawValue).trim();
    return singleValue ? [singleValue] : [];
  }
}
